import canvid from './canvid';
import d3 from 'd3';
import select from './select';
import swoopyArrow from './swoopy';

const DATES = [
  'September 3',
  'September 4',
  'September 5',
  'September 6',
  'September 7',
  'September 8',
  'September 9',
  'September 10',
  'September 11',
  'September 12',
  'September 13',
  'September 14',
  'September 15',
  'September 16',
];

export default class Scroller {
  constructor({ resizeObserver }) {
    this.el = select('#map-scroller');
    this.resizeObserver = resizeObserver;
    this.w = 800;
    this.h = 800;
    this.dateLabel = select('#date-label');

    this.makeSwoopy = this.makeSwoopy.bind(this);
  }

  init() {
    this.makeSwoopy();
    this.resizeObserver.add(() => this.makeSwoopy());

    this.baseMapImg = select('#basemap_img');
    this.dstCanvas = select('#map-scroller-dst');
    this.dstCanvas.setAttribute('width', this.w);
    this.dstCanvas.setAttribute('height', this.h);

    this.dstCtx = this.dstCanvas.getContext('2d');
    this.dstCtx.globalCompositeOperation = 'multiply';
    this.dstCtx.drawImage(this.baseMapImg, 0, 0, this.w, this.h);

    this.canvidControl = window.canvidControl = canvid({
      selector: '#canvid_container',
      videos: {
        clip1: {
          src: '/harvey-reservoirs/assets/images/usace-stitched-square.jpg',
          frames: 14,
          cols: 2,
          fps: 2,
          onFrame: f => {
            this.dstCtx.clearRect(0, 0, this.w, this.h);
            this.dstCtx.drawImage(this.baseMapImg, 0, 0, this.w, this.h);
            this.dstCtx.drawImage(this.canvidCanvas, 0, 0, this.w, this.h);
            this.dateLabel.innerHTML = DATES[canvidControl.getCurrentFrame()];

            if (f === 0) {
              this.canvidControl.pause();
              window.setTimeout(() => {
                this.canvidControl.resume();
              }, 1400);
            }
          },
        },
      },
      width: this.el.getBoundingClientRect().width,
      height: this.el.getBoundingClientRect().height,
      loaded: () => {
        this.canvidControl.play('clip1');
        // this.canvidControl.setCurrentFrame(0);
        // this.canvidControl.pause();
        this.canvidCanvas = select('.canvid');
      },
    });
  }

  makeSwoopy() {
    const w = 800;
    const h = 800;
    const bounds = this.el.getBoundingClientRect();
    const currentWidth = bounds.width;
    const currentHeight = bounds.height;

    const datumW = function(it) {
      return currentWidth * (it / w);
    };

    const datumH = function(it) {
      return currentHeight * (it / h);
    };

    const swoopy = swoopyArrow()
      .angle(Math.PI / 4)
      .x(d => d[0])
      .y(d => d[1]);

    const swoopycounter = swoopyArrow()
      .angle(Math.PI / 4)
      .clockwise(false)
      .x(d => d[0])
      .y(d => d[1]);

    const straightLine = d3.svg
      .line()
      .x(function(d) {
        return d.x;
      })
      .y(function(d) {
        return d.y;
      })
      .interpolate('linear');

    // Set up container
    d3.select('#map-scroller svg').remove();
    const svg = d3
      .select(this.el)
      .append('svg')
      .attr('xmlns', 'http://www.w3.org/2000/svg')
      .classed('arrow-container', true);

    // Define simple arrowhead marker
    svg
      .append('defs')
      .append('marker')
      .attr('id', 'arrowhead')
      .attr('viewBox', '-10 -10 20 20')
      .attr('refX', 0)
      .attr('refY', 0)
      .attr('markerWidth', 20)
      .attr('markerHeight', 20)
      .attr('stroke-width', 1)
      .attr('orient', 'auto')
      .append('polyline')
      .attr('stroke-linejoin', 'bevel')
      .attr('points', '-6.75,-6.75 0,0 -6.75,6.75')
      .attr('fill', '#222');

    //if (idx === 0) {
    // subdivisions
    svg
      .append('path')
      .attr('class', 'arrow')
      .attr('marker-end', 'url(#arrowhead)')
      .attr('stroke', '#222')
      .attr('fill', 'transparent')
      .datum([[datumW(110), datumH(500)], [datumW(188), datumH(545)]])
      .attr('d', swoopycounter);
    //}

    // releases
    svg
      .append('path')
      .attr('class', 'arrow')
      .attr('marker-end', 'url(#arrowhead)')
      .attr('stroke', '#222')
      .attr('fill', 'transparent')
      .datum([[datumW(412), datumH(660)], [datumW(385), datumH(621)]])
      .attr('d', swoopycounter);

    // // reservoirs extent label
    const reservoirsExtent = [
      { x: datumW(365), y: datumH(328) },
      { x: datumW(365), y: datumH(110) },
      { x: datumW(385), y: datumH(110) },
    ];

    const govLandExtent = [
      { x: datumW(395), y: datumH(350) },
      { x: datumW(395), y: datumH(135) },
      { x: datumW(415), y: datumH(135) },
    ];

    const dataExtent = [
      { x: datumW(664), y: datumH(370) },
      { x: datumW(664), y: datumH(330) },
    ];

    svg
      .append('path')
      .attr('stroke', '#222')
      .attr('fill', 'transparent')
      .attr('d', straightLine(reservoirsExtent));

    svg
      .append('path')
      .attr('stroke', '#222')
      .attr('fill', 'transparent')
      .attr('d', straightLine(govLandExtent));

    svg
      .append('path')
      .attr('stroke', '#222')
      .attr('fill', 'transparent')
      .attr('d', straightLine(dataExtent));
  }
}



// WEBPACK FOOTER //
// ./utils/scroller.js